import { AdCard } from "@/components/ad-card";
import type { Ad } from "@/lib/data";

export function RecommendedAds({
  ads,
  title = "Sizin üçün tövsiyələr",
  subtitle,
}: {
  ads: Ad[];
  title?: string;
  subtitle?: string;
}) {
  if (!ads.length) return null;
  return (
    <section className="mt-8">
      <div className="mb-3 flex items-end justify-between gap-3">
        <div>
          <h2 className="text-lg font-extrabold tracking-tight sm:text-xl">{title}</h2>
          {subtitle && <p className="text-xs text-muted-foreground">{subtitle}</p>}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-4">
        {ads.map((a, i) => (
          <AdCard key={`rec-${a.id}`} ad={a} index={i} />
        ))}
      </div>
    </section>
  );
}
